(function () {
  'use strict';

  var CFG = window.VORO_CART_CONFIG || {};
  var MONEY = CFG.moneyFormat || '${{amount}}';
  var ROOT_ID = 'voro-cart-drawer';
  var ACK_MAX_MS = 2500;

  var state = { cart: null, open: false, busy: false, recs: null, recsKey: '', recsSeq: 0, recIndex: 0, discountMsg: '' };
  var els = {};
  var listeners = { open: [], close: [], update: [], beforeCheckout: [], itemAdd: [], itemRemove: [] };

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withCents = whole + '.' + parts[1];
    return MONEY
      .replace(/\{\{\s*amount\s*\}\}/g, withCents)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCents.replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole.replace(/,/g, ' '));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function tmpl(str, vars) {
    return String(str || '').replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] != null ? vars[k] : '';
    });
  }

  function sized(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');
  }

  function emit(name, payload) {
    (listeners[name] || []).forEach(function (fn) { try { fn(payload); } catch (e) {} });
    try { document.dispatchEvent(new CustomEvent('voro-cart:' + name, { detail: payload })); } catch (e) {}
  }

  function readCart() {
    return fetch(CFG.routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function addFromForm(form) {
    var body = new FormData(form);
    return fetch(CFG.routes.cart_add + '.js', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(handleAddResponse);
  }

  function addVariant(id, quantity, properties, sellingPlan) {
    var item = { id: id, quantity: quantity || 1 };
    if (properties) item.properties = properties;
    if (sellingPlan) item.selling_plan = sellingPlan;
    return fetch(CFG.routes.cart_add + '.js', {
      method: 'POST',
      body: JSON.stringify({ items: [item] }),
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    }).then(handleAddResponse);
  }

  function handleAddResponse(r) {
    return r.json().then(function (data) {
      if (!r.ok) throw Object.assign(new Error(data.description || data.message || 'Add failed'), { data: data });
      emit('itemAdd', data);
      return readCart().then(setCart);
    });
  }

  function changeLine(key, quantity) {
    return fetch(CFG.routes.cart_change + '.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) return readCart().then(setCart);
      return r.json().then(setCart);
    });
  }

  function cartKey(cart) {
    return ((cart && cart.items) || []).map(function (l) { return String(l.product_id); }).sort().join(',');
  }

  function setCart(cart) {
    state.cart = cart;
    if (state.recsKey && cartKey(cart) !== state.recsKey) {
      state.recs = null;
      state.recsKey = '';
      state.recsSeq++;
      if (state.open && CFG.upsell.enabled) loadRecs();
    }
    emit('update', cart);
    syncCount(cart);
    render();
    loadCompareAt(cart);
    return cart;
  }

  function syncCount(cart) {
    document.querySelectorAll('[data-count], .item__count').forEach(function (n) {
      n.textContent = cart.item_count;
    });
  }

  function isGift(line) {
    return !!(line.properties && String(line.properties._free_gift) === '1');
  }

  function giftParent(line) {
    return line.properties && line.properties._gift_with;
  }

  function reconcileGifts(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var liveVariants = {};
    cart.items.forEach(function (l) { if (!isGift(l)) liveVariants[String(l.variant_id)] = true; });
    var orphan = cart.items.filter(function (l) {
      var p = giftParent(l);
      return isGift(l) && ((p && !liveVariants[String(p)]) || l.final_line_price > 0);
    });
    if (!orphan.length) return Promise.resolve(cart);
    return orphan.reduce(function (chain, l) {
      return chain.then(function () { return changeLine(l.key, 0); });
    }, Promise.resolve()).then(function () { return state.cart; });
  }

  var GIFT_NOTES = ['Free gift', 'Free gifts'];

  function giftNote(line) {
    var p = line.properties || {};
    for (var i = 0; i < GIFT_NOTES.length; i++) {
      if (p[GIFT_NOTES[i]]) return String(p[GIFT_NOTES[i]]);
    }
    return '';
  }

  function giftChipText(note) {
    var count = note.split(/,\s+/).reduce(function (n, part) {
      var m = part.match(/^(\d+)\s*[\u00d7x]\s/);
      return n + (m ? parseInt(m[1], 10) : 1);
    }, 0);
    var label = count > 1 ? CFG.text.giftsMany : CFG.text.giftsOne;
    return label ? String(label).replace('{count}', count) : '';
  }

  function visibleProps(line, hide) {
    var out = [];
    var p = line.properties || {};
    Object.keys(p).forEach(function (k) {
      if (k.charAt(0) === '_') return;
      if (hide && GIFT_NOTES.indexOf(k) !== -1) return;
      if (p[k] === '' || p[k] == null) return;
      out.push({ k: k, v: p[k] });
    });
    return out;
  }

  var capCache = {};
  var capPending = {};

  function productPath(line) {
    return line && line.url ? String(line.url).split('?')[0].split('#')[0] : '';
  }

  function compareAtLine(line) {
    var unit = capCache[line.variant_id];
    return unit ? unit * line.quantity : 0;
  }

  function loadCompareAt(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    var paths = [];
    cart.items.forEach(function (l) {
      var path = productPath(l);
      if (path && !capPending[path]) { capPending[path] = true; paths.push(path); }
    });
    if (!paths.length) return;

    Promise.all(paths.map(function (path) {
      return fetch(path + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return false;
          p.variants.forEach(function (v) {
            var cap = v.compare_at_price == null ? 0 : Number(v.compare_at_price);
            capCache[v.id] = cap > Number(v.price) ? cap : null;
          });
          return true;
        })
        .catch(function () { return false; });
    })).then(function (results) {
      if (results.some(Boolean)) render();
    });
  }

  function lineHTML(line) {
    var gift = isGift(line);
    var img = line.image ? sized(line.image, 160) : '';
    var now = Math.min(line.final_line_price, line.line_price);
    var was = Math.max(line.original_line_price, compareAtLine(line));
    var onSale = was > now;
    var note = giftNote(line);
    var chip = note ? giftChipText(note) : '';
    var props = visibleProps(line, !!chip);

    return '' +
      '<div class="vcd-line' + (gift ? ' vcd-line--gift' : '') + '" data-key="' + esc(line.key) + '">' +
        '<a class="vcd-line__img" href="' + esc(line.url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(line.product_title) + '" loading="lazy" width="80" height="80">' : '') +
        '</a>' +
        '<div class="vcd-line__body">' +
          '<a class="vcd-line__title" href="' + esc(line.url) + '">' + esc(line.product_title) + '</a>' +
          (line.variant_title ? '<div class="vcd-line__variant">' + esc(line.variant_title) + '</div>' : '') +
          (props.length ? '<div class="vcd-line__props">' + props.map(function (p) {
            return '<span>' + esc(p.k) + ': ' + esc(p.v) + '</span>';
          }).join('') + '</div>' : '') +
          (chip ? '<div class="vcd-line__gifts" title="' + esc(note) + '">' +
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>' +
            '<span>' + esc(chip) + '</span></div>' : '') +
          (gift ? '<div class="vcd-line__gift">' + esc(CFG.text.giftLabel) + '</div>' : '') +
          '<div class="vcd-line__actions">' +
            (gift
              ? '<span class="vcd-line__qtylocked">' + esc(CFG.text.qtyLabel) + ' ' + line.quantity + '</span>'
              : '<div class="vcd-qty">' +
                  '<button type="button" class="vcd-qty__btn" data-act="dec" aria-label="' + esc(CFG.text.decrease) + '">&minus;</button>' +
                  '<span class="vcd-qty__val">' + line.quantity + '</span>' +
                  '<button type="button" class="vcd-qty__btn" data-act="inc" aria-label="' + esc(CFG.text.increase) + '">+</button>' +
                '</div>') +
            '<button type="button" class="vcd-line__remove" data-act="remove" aria-label="' + esc(CFG.text.remove) + '">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M6 7h12l-1 13H7L6 7zm3-3h6l1 2H8l1-2z"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="vcd-line__price">' +
          (onSale ? '<s class="vcd-line__was">' + money(was) + '</s>' : '') +
          '<span class="vcd-line__now' + (onSale ? ' is-sale' : '') + '">' + money(now) + '</span>' +
        '</div>' +
      '</div>';
  }

  function recsHTML() {
    if (!CFG.upsell.enabled || !state.recs || !state.recs.length) return '';
    var perView = 3;
    var cards = state.recs.map(function (p) {
      var v = p.variants && p.variants[0];
      if (!v) return '';
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var multi = p.variants.length > 1;
      return '' +
        '<div class="vcd-rec" data-variant="' + esc(v.id) + '">' +
          '<a class="vcd-rec__img" href="' + esc(p.url) + '">' +
            (p.featured_image ? '<img src="' + esc(sized(p.featured_image, 128)) + '" alt="' + esc(p.title) + '" loading="lazy" width="64" height="64">' : '') +
          '</a>' +
          '<div class="vcd-rec__body">' +
            '<a class="vcd-rec__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            (multi
              ? '<select class="vcd-rec__variant" aria-label="' + esc(p.title) + '">' + p.variants.map(function (vv) {
                  return '<option value="' + esc(vv.id) + '"' + (vv.available ? '' : ' disabled') + '>' + esc(vv.title) + '</option>';
                }).join('') + '</select>'
              : '') +
            '<div class="vcd-rec__price">' +
              (onSale ? '<s>' + money(v.compare_at_price) + '</s> ' : '') +
              '<span' + (onSale ? ' class="is-sale"' : '') + '>' + money(v.price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="vcd-rec__add" data-act="rec-add">' + esc(CFG.upsell.buttonText) + '</button>' +
        '</div>';
    }).join('');

    var pages = Math.ceil(state.recs.length / perView);
    return '' +
      '<div class="vcd-recs">' +
        '<div class="vcd-recs__head">' +
          '<div class="vcd-recs__title">' + esc(CFG.upsell.title) + '</div>' +
          (pages > 1 ? '<div class="vcd-recs__nav">' +
            '<button type="button" data-act="rec-prev" aria-label="' + esc(CFG.text.prev) + '">&lsaquo;</button>' +
            '<button type="button" data-act="rec-next" aria-label="' + esc(CFG.text.next) + '">&rsaquo;</button>' +
          '</div>' : '') +
        '</div>' +
        '<div class="vcd-recs__track" data-page="' + state.recIndex + '">' + cards + '</div>' +
      '</div>';
  }

  function discountHTML() {
    if (!CFG.discount.enabled) return '';
    var cart = state.cart || {};
    var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    var saved = cart.total_discount || 0;
    return '' +
      '<div class="vcd-disc">' +
        (codes.length
          ? '<div class="vcd-disc__tags">' + codes.map(function (d) {
              return '<span class="vcd-disc__tag">' + esc(d.code) + '</span>';
            }).join('') + '</div>'
          : '') +
        '<button type="button" class="vcd-disc__link" data-act="disc-toggle" aria-expanded="false">' +
          esc(CFG.discount.linkText) +
        '</button>' +
        '<div class="vcd-disc__form" hidden>' +
          '<input type="text" class="vcd-disc__input" placeholder="' + esc(CFG.discount.label) + '" aria-label="' + esc(CFG.discount.label) + '">' +
          '<button type="button" class="vcd-disc__apply" data-act="disc-apply">' + esc(CFG.discount.buttonText) + '</button>' +
        '</div>' +
        (state.discountMsg ? '<div class="vcd-disc__msg">' + esc(state.discountMsg) + '</div>' : '') +
        (saved > 0 ? '<div class="vcd-disc__saved"><span>' + esc(CFG.discount.savingsLabel) + '</span><span>&minus;' + money(saved) + '</span></div>' : '') +
      '</div>';
  }

  function shippingHTML() {
    if (!CFG.shipping.note) return '';
    return '<div class="vcd-ship">' + esc(CFG.shipping.note) + '</div>';
  }

  function emptyHTML() {
    return '' +
      '<div class="vcd-empty">' +
        (CFG.empty.image ? '<img class="vcd-empty__img" src="' + esc(CFG.empty.image) + '" alt="" width="56" height="56">' : '') +
        '<p class="vcd-empty__text">' + esc(CFG.empty.text) + '</p>' +
        (CFG.empty.buttonText ? '<a class="vcd-empty__cta" href="' + esc(CFG.empty.url) + '">' + esc(CFG.empty.buttonText) + '</a>' : '') +
      '</div>';
  }

  function render() {
    if (!els.root) return;
    var cart = state.cart;
    if (!cart) return;

    els.title.textContent = tmpl(CFG.text.title, { item_count: cart.item_count });

    if (!cart.item_count) {
      els.content.innerHTML = emptyHTML();
      els.footer.hidden = true;
      return;
    }
    els.footer.hidden = false;

    els.content.innerHTML =
      '<div class="vcd-lines">' + cart.items.map(lineHTML).join('') + '</div>' + recsHTML();

    els.footer.innerHTML =
      shippingHTML() +
      discountHTML() +
      '<div class="vcd-subtotal"><span>' + esc(CFG.text.subtotal) + '</span><span>' + money(cart.total_price) + '</span></div>' +
      '<form action="' + esc(CFG.routes.cart) + '" method="post" class="vcd-checkout-form">' +
        '<button type="submit" name="checkout" class="vcd-checkout">' +
          esc(tmpl(CFG.text.checkout, { price: money(cart.total_price) })) +
        '</button>' +
      '</form>';
  }

  function open() {
    if (!els.root) return;
    state.open = true;
    els.root.classList.add('is-open');
    els.root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vcd-locked');
    emit('open', state.cart);
    if (CFG.upsell.enabled && !state.recs && !state.recsKey) loadRecs();
    var f = els.panel.querySelector('button, a, input');
    if (f) f.focus();
  }

  function close() {
    if (!els.root) return;
    state.open = false;
    els.root.classList.remove('is-open');
    els.root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vcd-locked');
    emit('close', state.cart);
  }

  function loadRecs() {
    var cart = state.cart;
    if (!cart || !cart.items.length) return;
    var seq = ++state.recsSeq;
    state.recsKey = cartKey(cart);
    var seed = cart.items[0].product_id;
    var skip = {};
    cart.items.forEach(function (l) { skip[String(l.product_id)] = true; });

    var url = function (intent) {
      return CFG.routes.recommendations + '?product_id=' + seed + '&limit=10&intent=' + intent;
    };
    var get = function (intent) {
      return fetch(url(intent), { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    };
    var pick = function (json) {
      return (json.products || []).filter(function (p) {
        return !skip[String(p.id)] && p.available;
      }).slice(0, CFG.upsell.limit);
    };
    var gifts = fetch(CFG.routes.cart + '?sections=voro-cart-gifts', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var m = /data-vcd-gift-ids="([^"]*)"/.exec((j && j['voro-cart-gifts']) || '');
        (m ? m[1].split(',') : []).forEach(function (id) { if (id) skip[id] = true; });
      })
      .catch(function () {});

    Promise.all([get('complementary'), gifts])
      .then(function (res) {
        var got = pick(res[0]);
        if (got.length) return got;
        return get('related').then(pick);
      })
      .then(function (products) {
        if (seq !== state.recsSeq) return;
        state.recs = products;
        state.recIndex = 0;
        render();
      })
      .catch(function () { if (seq === state.recsSeq) state.recs = []; });
  }

  function recError(card, text) {
    if (!card) return;
    var el = card.querySelector('.vcd-rec__err');
    if (!text) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'vcd-rec__err';
      el.setAttribute('role', 'status');
      card.appendChild(el);
    }
    el.textContent = text;
  }

  function applyDiscount(code) {
    if (!code) return;
    state.discountMsg = '';
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { return readCart(); })
      .then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        })[0];
        state.discountMsg = hit && hit.applicable
          ? ''
          : tmpl(CFG.discount.errorText, { discount: code });
        setCart(cart);
      });
  }

  function insideDrawer(node) {
    return !!(node && node.closest && node.closest('#' + ROOT_ID));
  }

  function onSubmitCapture(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (insideDrawer(form)) return;
    if (e.defaultPrevented) return;

    if (form.closest('[data-vpdp-root]')) return;

    if (!CFG.openOnAdd) return;

    e.preventDefault();

    if (state.busy) return;
    state.busy = true;
    setBusy(form, true);

    addFromForm(form)
      .then(function () { open(); })
      .catch(function (err) {
        setBusy(form, false);
        state.busy = false;
        form.removeEventListener('submit', onSubmitCapture, true);
        HTMLFormElement.prototype.submit.call(form);
        throw err;
      })
      .then(function () { setBusy(form, false); state.busy = false; });
  }

  function setBusy(form, on) {
    var btn = form.querySelector('[name=add], button[type=submit]');
    if (!btn) return;
    ackBusy(btn, !!on);
  }

  var ackTimer = null;
  function ackBusy(btn, on) {
    if (ackTimer) { clearTimeout(ackTimer); ackTimer = null; }
    if (!on) {
      document.querySelectorAll('.vcd-busy').forEach(function (b) { b.classList.remove('vcd-busy'); });
      return;
    }
    btn.classList.add('vcd-busy');
    ackTimer = setTimeout(function () { ackBusy(null, false); }, ACK_MAX_MS);
  }

  function onBuyClickCapture(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (insideDrawer(t)) return;
    var btn = t.closest('[data-vpdp-atc], .vpdp-atc, form[action*="/cart/add"] [name=add], form[action*="/cart/add"] button[type=submit]');
    if (!btn) return;
    ackBusy(btn, true);
  }

  function onClickCapture(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (insideDrawer(t)) return;
    var trigger = t.closest('.minicart__button, a[href$="/cart"], [data-voro-cart-open]');
    if (!trigger) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.which === 2) return;
    if (location.pathname === CFG.routes.cart) return;
    if (!els.root) return;
    e.preventDefault();
    readCart().then(setCart).then(reconcileGifts).then(open);
  }

  function bindDrawer() {
    els.root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-act="close"]') || t.classList.contains('vcd-overlay')) return close();

      var act = t.closest('[data-act]');
      if (!act) return;
      var a = act.getAttribute('data-act');
      var lineEl = act.closest('.vcd-line');
      var key = lineEl && lineEl.getAttribute('data-key');
      var line = key && state.cart.items.filter(function (l) { return l.key === key; })[0];

      if (a === 'inc' && line) return void changeLine(key, line.quantity + 1).then(reconcileGifts);
      if (a === 'dec' && line) return void changeLine(key, Math.max(0, line.quantity - 1)).then(reconcileGifts);
      if (a === 'remove' && line) {
        emit('itemRemove', line);
        return void changeLine(key, 0).then(reconcileGifts);
      }

      if (a === 'rec-add') {
        var card = act.closest('.vcd-rec');
        var sel = card.querySelector('.vcd-rec__variant');
        var vid = sel ? sel.value : card.getAttribute('data-variant');
        act.disabled = true;
        recError(card, '');
        return void addVariant(vid, 1)
          .catch(function (err) {
            act.disabled = false;
            recError(card, (err && err.message) || 'Sorry, that item could not be added.');
          });
      }
      if (a === 'rec-prev') { state.recIndex = Math.max(0, state.recIndex - 1); return void render(); }
      if (a === 'rec-next') { state.recIndex = state.recIndex + 1; return void render(); }

      if (a === 'disc-toggle') {
        var form = els.root.querySelector('.vcd-disc__form');
        form.hidden = !form.hidden;
        act.setAttribute('aria-expanded', String(!form.hidden));
        if (!form.hidden) form.querySelector('input').focus();
        return;
      }
      if (a === 'disc-apply') {
        var input = els.root.querySelector('.vcd-disc__input');
        return void applyDiscount(input.value.trim());
      }
    });

    els.root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.classList.contains('vcd-disc__input')) {
        e.preventDefault();
        applyDiscount(e.target.value.trim());
      }
    });

    els.root.addEventListener('submit', function (e) {
      if (e.target.classList.contains('vcd-checkout-form')) emit('beforeCheckout', state.cart);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) close();
    });
  }

  function init() {
    els.root = document.getElementById(ROOT_ID);
    if (!els.root) return;
    els.panel = els.root.querySelector('.vcd-panel');
    els.title = els.root.querySelector('.vcd-title');
    els.content = els.root.querySelector('.vcd-content');
    els.footer = els.root.querySelector('.vcd-footer');
    bindDrawer();
    readCart().then(setCart);
  }

  document.addEventListener('submit', onSubmitCapture, true);
  document.addEventListener('click', onClickCapture, true);
  document.addEventListener('click', onBuyClickCapture, true);

  document.addEventListener('voro:cart:added', function () { ackBusy(null, false); });
  document.addEventListener('voro-cart:open', function () { ackBusy(null, false); });
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1 && /extend-offers-modal/i.test(added[j].id || '')) {
          ackBusy(null, false);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('voro:cart:added', function () {
    if (!CFG.openOnAdd) return;
    readCart().then(setCart).then(reconcileGifts).then(open);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.voroCart = {
    openCart: function () { return readCart().then(setCart).then(reconcileGifts).then(open); },
    closeCart: close,
    toggleCart: function () { state.open ? close() : open(); },
    refreshCart: function () { return readCart().then(setCart); },
    getCartData: function () { return state.cart; },
    isOpen: function () { return state.open; },
    getItemCount: function () { return state.cart ? state.cart.item_count : 0; },
    addItem: addVariant,
    removeItem: function (key) { return changeLine(key, 0); },
    updateItemQuantity: changeLine,
    clearCart: function () {
      return fetch(CFG.routes.cart + '/clear.js', { method: 'POST', credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(setCart);
    },
    onCartOpen: function (fn) { listeners.open.push(fn); },
    onCartClose: function (fn) { listeners.close.push(fn); },
    onCartUpdate: function (fn) { listeners.update.push(fn); },
    onBeforeCheckout: function (fn) { listeners.beforeCheckout.push(fn); },
    onItemAdd: function (fn) { listeners.itemAdd.push(fn); },
    onItemRemove: function (fn) { listeners.itemRemove.push(fn); }
  };
})();
